import { createSlice } from '@reduxjs/toolkit';
import { getCurrentWeekStart } from '../../../utils/dateUtils';

const initialState = {
  viewType: 'board', // 'board' or 'list'
  filters: {
    status: null,
    assignedTo: null,
    category: null,
    priority: null,
    dateRange: null
  },
  sorting: {
    field: 'dueDate',
    direction: 'asc'
  },  boardView: {
    currentWeekStart: getCurrentWeekStart().toISOString(), // Set default to current week's Monday
    showCompletedChores: true,
    timeScope: 'week', // 'day' or 'week'
    choreScope: 'family', // 'my' or 'family'
    subView: 'current' // 'current', 'suggestions', 'ideas'
  },
  listView: {
    groupBy: null, // null, 'assignee', 'dueDate', 'status', etc.
    showInstances: true
  }
};

const choreViewPreferenceSlice = createSlice({
  name: 'choreViewPreference',
  initialState,
  reducers: {
    setViewType(state, action) {
      state.viewType = action.payload;
    },
    setFilter(state, action) {
      const { filterType, value } = action.payload;
      state.filters[filterType] = value;
    },
    clearFilters(state) {
      state.filters = initialState.filters;
    },
    setSorting(state, action) {
      const { field, direction } = action.payload;
      state.sorting = { field, direction };
    },
    setBoardViewOptions(state, action) {
      state.boardView = {
        ...state.boardView,
        ...action.payload
      };
    },
    setListViewOptions(state, action) {
      state.listView = {
        ...state.listView,
        ...action.payload
      };
    },
    resetViewPreferences() {
      return initialState;
    }
  }
});

export const {
  setViewType,
  setFilter,
  clearFilters,
  setSorting,
  setBoardViewOptions,
  setListViewOptions,
  resetViewPreferences
} = choreViewPreferenceSlice.actions;

// Selectors
export const selectViewType = (state) => state.choreViewPreference.viewType;
export const selectFilters = (state) => state.choreViewPreference.filters;
export const selectSorting = (state) => state.choreViewPreference.sorting;
export const selectBoardViewOptions = (state) => state.choreViewPreference.boardView;
export const selectListViewOptions = (state) => state.choreViewPreference.listView;

export default choreViewPreferenceSlice.reducer;
